'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * DishImage Component
 *
 * Renders a dish image with fallback to placeholder icon.
 * Handles image loading errors gracefully by hiding the broken image
 * and showing the placeholder icon instead.
 */
export default class DishImage extends Component {
    static propTypes = {
        imageUrl: PropTypes.string,
        title: PropTypes.string.isRequired,
    };

    static defaultProps = {
        imageUrl: null,
    };

    handleImageError = (e) => {
        e.target.style.display = 'none';
        e.target.nextSibling.style.display = 'block';
    }

    render() {
        const { imageUrl, title } = this.props;

        return (
            <div className="meal-item-icon">
                {imageUrl ? (
                    <img
                        src={imageUrl}
                        alt={title}
                        className="dish-image"
                        onError={this.handleImageError}
                    />
                ) : null}
                <div className="placeholder-icon" style={{display: imageUrl ? 'none' : 'block'}}>
                    <i className="icon-dish" />
                </div>
            </div>
        );
    }
}
